// AUTO-GENERATED static country list — offline/unauthenticated fallback for the country-code
// dropdown (e.g. the public password-reset page, where the authenticated get_countries query
// returns Unauthorized). Regenerate via awesome-phonenumber + Intl.DisplayNames. Flags are
// served by the public flagcdn.com CDN (no auth required).
//
// NOTE: country_code is stored WITHOUT a leading "+" to match PAPI/get_countries (e.g. "972").
// PAPI looks up users by an exact country_code match, so the "+" must NOT be sent.
import { Country } from '@app/models/country.model'

export const STATIC_COUNTRIES: Country[] = [
  {
    id: "AF",
    iso: "AF",
    country_code: "93",
    name_en: "Afghanistan",
    name_he: "אפגניסטן",
    icon: "https://flagcdn.com/w40/af.png"
  },
  {
    id: "AX",
    iso: "AX",
    country_code: "358",
    name_en: "Åland Islands",
    name_he: "איי אולנד",
    icon: "https://flagcdn.com/w40/ax.png"
  },
  {
    id: "AL",
    iso: "AL",
    country_code: "355",
    name_en: "Albania",
    name_he: "אלבניה",
    icon: "https://flagcdn.com/w40/al.png"
  },
  {
    id: "DZ",
    iso: "DZ",
    country_code: "213",
    name_en: "Algeria",
    name_he: "אלג׳יריה",
    icon: "https://flagcdn.com/w40/dz.png"
  },
  {
    id: "AS",
    iso: "AS",
    country_code: "1",
    name_en: "American Samoa",
    name_he: "סמואה האמריקנית",
    icon: "https://flagcdn.com/w40/as.png"
  },
  {
    id: "AD",
    iso: "AD",
    country_code: "376",
    name_en: "Andorra",
    name_he: "אנדורה",
    icon: "https://flagcdn.com/w40/ad.png"
  },
  {
    id: "AO",
    iso: "AO",
    country_code: "244",
    name_en: "Angola",
    name_he: "אנגולה",
    icon: "https://flagcdn.com/w40/ao.png"
  },
  {
    id: "AI",
    iso: "AI",
    country_code: "1",
    name_en: "Anguilla",
    name_he: "אנגווילה",
    icon: "https://flagcdn.com/w40/ai.png"
  },
  {
    id: "AG",
    iso: "AG",
    country_code: "1",
    name_en: "Antigua & Barbuda",
    name_he: "אנטיגואה וברבודה",
    icon: "https://flagcdn.com/w40/ag.png"
  },
  {
    id: "AR",
    iso: "AR",
    country_code: "54",
    name_en: "Argentina",
    name_he: "ארגנטינה",
    icon: "https://flagcdn.com/w40/ar.png"
  },
  {
    id: "AM",
    iso: "AM",
    country_code: "374",
    name_en: "Armenia",
    name_he: "ארמניה",
    icon: "https://flagcdn.com/w40/am.png"
  },
  {
    id: "AW",
    iso: "AW",
    country_code: "297",
    name_en: "Aruba",
    name_he: "ארובה",
    icon: "https://flagcdn.com/w40/aw.png"
  },
  {
    id: "AC",
    iso: "AC",
    country_code: "247",
    name_en: "Ascension Island",
    name_he: "האי אסנשן",
    icon: "https://flagcdn.com/w40/ac.png"
  },
  {
    id: "AU",
    iso: "AU",
    country_code: "61",
    name_en: "Australia",
    name_he: "אוסטרליה",
    icon: "https://flagcdn.com/w40/au.png"
  },
  {
    id: "AT",
    iso: "AT",
    country_code: "43",
    name_en: "Austria",
    name_he: "אוסטריה",
    icon: "https://flagcdn.com/w40/at.png"
  },
  {
    id: "AZ",
    iso: "AZ",
    country_code: "994",
    name_en: "Azerbaijan",
    name_he: "אזרבייג׳ן",
    icon: "https://flagcdn.com/w40/az.png"
  },
  {
    id: "BS",
    iso: "BS",
    country_code: "1",
    name_en: "Bahamas",
    name_he: "איי בהאמה",
    icon: "https://flagcdn.com/w40/bs.png"
  },
  {
    id: "BH",
    iso: "BH",
    country_code: "973",
    name_en: "Bahrain",
    name_he: "בחריין",
    icon: "https://flagcdn.com/w40/bh.png"
  },
  {
    id: "BD",
    iso: "BD",
    country_code: "880",
    name_en: "Bangladesh",
    name_he: "בנגלדש",
    icon: "https://flagcdn.com/w40/bd.png"
  },
  {
    id: "BB",
    iso: "BB",
    country_code: "1",
    name_en: "Barbados",
    name_he: "ברבדוס",
    icon: "https://flagcdn.com/w40/bb.png"
  },
  {
    id: "BY",
    iso: "BY",
    country_code: "375",
    name_en: "Belarus",
    name_he: "בלארוס",
    icon: "https://flagcdn.com/w40/by.png"
  },
  {
    id: "BE",
    iso: "BE",
    country_code: "32",
    name_en: "Belgium",
    name_he: "בלגיה",
    icon: "https://flagcdn.com/w40/be.png"
  },
  {
    id: "BZ",
    iso: "BZ",
    country_code: "501",
    name_en: "Belize",
    name_he: "בליז",
    icon: "https://flagcdn.com/w40/bz.png"
  },
  {
    id: "BJ",
    iso: "BJ",
    country_code: "229",
    name_en: "Benin",
    name_he: "בנין",
    icon: "https://flagcdn.com/w40/bj.png"
  },
  {
    id: "BM",
    iso: "BM",
    country_code: "1",
    name_en: "Bermuda",
    name_he: "ברמודה",
    icon: "https://flagcdn.com/w40/bm.png"
  },
  {
    id: "BT",
    iso: "BT",
    country_code: "975",
    name_en: "Bhutan",
    name_he: "בהוטן",
    icon: "https://flagcdn.com/w40/bt.png"
  },
  {
    id: "BO",
    iso: "BO",
    country_code: "591",
    name_en: "Bolivia",
    name_he: "בוליביה",
    icon: "https://flagcdn.com/w40/bo.png"
  },
  {
    id: "BA",
    iso: "BA",
    country_code: "387",
    name_en: "Bosnia & Herzegovina",
    name_he: "בוסניה והרצגובינה",
    icon: "https://flagcdn.com/w40/ba.png"
  },
  {
    id: "BW",
    iso: "BW",
    country_code: "267",
    name_en: "Botswana",
    name_he: "בוטסואנה",
    icon: "https://flagcdn.com/w40/bw.png"
  },
  {
    id: "BR",
    iso: "BR",
    country_code: "55",
    name_en: "Brazil",
    name_he: "ברזיל",
    icon: "https://flagcdn.com/w40/br.png"
  },
  {
    id: "IO",
    iso: "IO",
    country_code: "246",
    name_en: "British Indian Ocean Territory",
    name_he: "הטריטוריה הבריטית באוקיינוס ההודי",
    icon: "https://flagcdn.com/w40/io.png"
  },
  {
    id: "VG",
    iso: "VG",
    country_code: "1",
    name_en: "British Virgin Islands",
    name_he: "איי הבתולה הבריטיים",
    icon: "https://flagcdn.com/w40/vg.png"
  },
  {
    id: "BN",
    iso: "BN",
    country_code: "673",
    name_en: "Brunei",
    name_he: "ברוניי",
    icon: "https://flagcdn.com/w40/bn.png"
  },
  {
    id: "BG",
    iso: "BG",
    country_code: "359",
    name_en: "Bulgaria",
    name_he: "בולגריה",
    icon: "https://flagcdn.com/w40/bg.png"
  },
  {
    id: "BF",
    iso: "BF",
    country_code: "226",
    name_en: "Burkina Faso",
    name_he: "בורקינה פאסו",
    icon: "https://flagcdn.com/w40/bf.png"
  },
  {
    id: "BI",
    iso: "BI",
    country_code: "257",
    name_en: "Burundi",
    name_he: "בורונדי",
    icon: "https://flagcdn.com/w40/bi.png"
  },
  {
    id: "KH",
    iso: "KH",
    country_code: "855",
    name_en: "Cambodia",
    name_he: "קמבודיה",
    icon: "https://flagcdn.com/w40/kh.png"
  },
  {
    id: "CM",
    iso: "CM",
    country_code: "237",
    name_en: "Cameroon",
    name_he: "קמרון",
    icon: "https://flagcdn.com/w40/cm.png"
  },
  {
    id: "CA",
    iso: "CA",
    country_code: "1",
    name_en: "Canada",
    name_he: "קנדה",
    icon: "https://flagcdn.com/w40/ca.png"
  },
  {
    id: "CV",
    iso: "CV",
    country_code: "238",
    name_en: "Cape Verde",
    name_he: "כף ורדה",
    icon: "https://flagcdn.com/w40/cv.png"
  },
  {
    id: "BQ",
    iso: "BQ",
    country_code: "599",
    name_en: "Caribbean Netherlands",
    name_he: "האיים הקריביים ההולנדיים",
    icon: "https://flagcdn.com/w40/bq.png"
  },
  {
    id: "KY",
    iso: "KY",
    country_code: "1",
    name_en: "Cayman Islands",
    name_he: "איי קיימן",
    icon: "https://flagcdn.com/w40/ky.png"
  },
  {
    id: "CF",
    iso: "CF",
    country_code: "236",
    name_en: "Central African Republic",
    name_he: "הרפובליקה המרכז-אפריקאית",
    icon: "https://flagcdn.com/w40/cf.png"
  },
  {
    id: "TD",
    iso: "TD",
    country_code: "235",
    name_en: "Chad",
    name_he: "צ׳אד",
    icon: "https://flagcdn.com/w40/td.png"
  },
  {
    id: "CL",
    iso: "CL",
    country_code: "56",
    name_en: "Chile",
    name_he: "צ׳ילה",
    icon: "https://flagcdn.com/w40/cl.png"
  },
  {
    id: "CN",
    iso: "CN",
    country_code: "86",
    name_en: "China",
    name_he: "סין",
    icon: "https://flagcdn.com/w40/cn.png"
  },
  {
    id: "CX",
    iso: "CX",
    country_code: "61",
    name_en: "Christmas Island",
    name_he: "אי חג המולד",
    icon: "https://flagcdn.com/w40/cx.png"
  },
  {
    id: "CC",
    iso: "CC",
    country_code: "61",
    name_en: "Cocos (Keeling) Islands",
    name_he: "איי קוקוס (קילינג)",
    icon: "https://flagcdn.com/w40/cc.png"
  },
  {
    id: "CO",
    iso: "CO",
    country_code: "57",
    name_en: "Colombia",
    name_he: "קולומביה",
    icon: "https://flagcdn.com/w40/co.png"
  },
  {
    id: "KM",
    iso: "KM",
    country_code: "269",
    name_en: "Comoros",
    name_he: "קומורו",
    icon: "https://flagcdn.com/w40/km.png"
  },
  {
    id: "CG",
    iso: "CG",
    country_code: "242",
    name_en: "Congo - Brazzaville",
    name_he: "קונגו - ברזאויל",
    icon: "https://flagcdn.com/w40/cg.png"
  },
  {
    id: "CD",
    iso: "CD",
    country_code: "243",
    name_en: "Congo - Kinshasa",
    name_he: "קונגו - קינשאסה",
    icon: "https://flagcdn.com/w40/cd.png"
  },
  {
    id: "CK",
    iso: "CK",
    country_code: "682",
    name_en: "Cook Islands",
    name_he: "איי קוק",
    icon: "https://flagcdn.com/w40/ck.png"
  },
  {
    id: "CR",
    iso: "CR",
    country_code: "506",
    name_en: "Costa Rica",
    name_he: "קוסטה ריקה",
    icon: "https://flagcdn.com/w40/cr.png"
  },
  {
    id: "CI",
    iso: "CI",
    country_code: "225",
    name_en: "Côte d’Ivoire",
    name_he: "חוף השנהב",
    icon: "https://flagcdn.com/w40/ci.png"
  },
  {
    id: "HR",
    iso: "HR",
    country_code: "385",
    name_en: "Croatia",
    name_he: "קרואטיה",
    icon: "https://flagcdn.com/w40/hr.png"
  },
  {
    id: "CU",
    iso: "CU",
    country_code: "53",
    name_en: "Cuba",
    name_he: "קובה",
    icon: "https://flagcdn.com/w40/cu.png"
  },
  {
    id: "CW",
    iso: "CW",
    country_code: "599",
    name_en: "Curaçao",
    name_he: "קוראסאו",
    icon: "https://flagcdn.com/w40/cw.png"
  },
  {
    id: "CY",
    iso: "CY",
    country_code: "357",
    name_en: "Cyprus",
    name_he: "קפריסין",
    icon: "https://flagcdn.com/w40/cy.png"
  },
  {
    id: "CZ",
    iso: "CZ",
    country_code: "420",
    name_en: "Czechia",
    name_he: "צ׳כיה",
    icon: "https://flagcdn.com/w40/cz.png"
  },
  {
    id: "DK",
    iso: "DK",
    country_code: "45",
    name_en: "Denmark",
    name_he: "דנמרק",
    icon: "https://flagcdn.com/w40/dk.png"
  },
  {
    id: "DJ",
    iso: "DJ",
    country_code: "253",
    name_en: "Djibouti",
    name_he: "ג׳יבוטי",
    icon: "https://flagcdn.com/w40/dj.png"
  },
  {
    id: "DM",
    iso: "DM",
    country_code: "1",
    name_en: "Dominica",
    name_he: "דומיניקה",
    icon: "https://flagcdn.com/w40/dm.png"
  },
  {
    id: "DO",
    iso: "DO",
    country_code: "1",
    name_en: "Dominican Republic",
    name_he: "הרפובליקה הדומיניקנית",
    icon: "https://flagcdn.com/w40/do.png"
  },
  {
    id: "EC",
    iso: "EC",
    country_code: "593",
    name_en: "Ecuador",
    name_he: "אקוודור",
    icon: "https://flagcdn.com/w40/ec.png"
  },
  {
    id: "EG",
    iso: "EG",
    country_code: "20",
    name_en: "Egypt",
    name_he: "מצרים",
    icon: "https://flagcdn.com/w40/eg.png"
  },
  {
    id: "SV",
    iso: "SV",
    country_code: "503",
    name_en: "El Salvador",
    name_he: "אל סלבדור",
    icon: "https://flagcdn.com/w40/sv.png"
  },
  {
    id: "GQ",
    iso: "GQ",
    country_code: "240",
    name_en: "Equatorial Guinea",
    name_he: "גינאה המשוונית",
    icon: "https://flagcdn.com/w40/gq.png"
  },
  {
    id: "ER",
    iso: "ER",
    country_code: "291",
    name_en: "Eritrea",
    name_he: "אריתריאה",
    icon: "https://flagcdn.com/w40/er.png"
  },
  {
    id: "EE",
    iso: "EE",
    country_code: "372",
    name_en: "Estonia",
    name_he: "אסטוניה",
    icon: "https://flagcdn.com/w40/ee.png"
  },
  {
    id: "SZ",
    iso: "SZ",
    country_code: "268",
    name_en: "Eswatini",
    name_he: "אסוואטיני",
    icon: "https://flagcdn.com/w40/sz.png"
  },
  {
    id: "ET",
    iso: "ET",
    country_code: "251",
    name_en: "Ethiopia",
    name_he: "אתיופיה",
    icon: "https://flagcdn.com/w40/et.png"
  },
  {
    id: "FK",
    iso: "FK",
    country_code: "500",
    name_en: "Falkland Islands",
    name_he: "איי פוקלנד",
    icon: "https://flagcdn.com/w40/fk.png"
  },
  {
    id: "FO",
    iso: "FO",
    country_code: "298",
    name_en: "Faroe Islands",
    name_he: "איי פארו",
    icon: "https://flagcdn.com/w40/fo.png"
  },
  {
    id: "FJ",
    iso: "FJ",
    country_code: "679",
    name_en: "Fiji",
    name_he: "פיג׳י",
    icon: "https://flagcdn.com/w40/fj.png"
  },
  {
    id: "FI",
    iso: "FI",
    country_code: "358",
    name_en: "Finland",
    name_he: "פינלנד",
    icon: "https://flagcdn.com/w40/fi.png"
  },
  {
    id: "FR",
    iso: "FR",
    country_code: "33",
    name_en: "France",
    name_he: "צרפת",
    icon: "https://flagcdn.com/w40/fr.png"
  },
  {
    id: "GF",
    iso: "GF",
    country_code: "594",
    name_en: "French Guiana",
    name_he: "גיאנה הצרפתית",
    icon: "https://flagcdn.com/w40/gf.png"
  },
  {
    id: "PF",
    iso: "PF",
    country_code: "689",
    name_en: "French Polynesia",
    name_he: "פולינזיה הצרפתית",
    icon: "https://flagcdn.com/w40/pf.png"
  },
  {
    id: "GA",
    iso: "GA",
    country_code: "241",
    name_en: "Gabon",
    name_he: "גבון",
    icon: "https://flagcdn.com/w40/ga.png"
  },
  {
    id: "GM",
    iso: "GM",
    country_code: "220",
    name_en: "Gambia",
    name_he: "גמביה",
    icon: "https://flagcdn.com/w40/gm.png"
  },
  {
    id: "GE",
    iso: "GE",
    country_code: "995",
    name_en: "Georgia",
    name_he: "גאורגיה",
    icon: "https://flagcdn.com/w40/ge.png"
  },
  {
    id: "DE",
    iso: "DE",
    country_code: "49",
    name_en: "Germany",
    name_he: "גרמניה",
    icon: "https://flagcdn.com/w40/de.png"
  },
  {
    id: "GH",
    iso: "GH",
    country_code: "233",
    name_en: "Ghana",
    name_he: "גאנה",
    icon: "https://flagcdn.com/w40/gh.png"
  },
  {
    id: "GI",
    iso: "GI",
    country_code: "350",
    name_en: "Gibraltar",
    name_he: "גיברלטר",
    icon: "https://flagcdn.com/w40/gi.png"
  },
  {
    id: "GR",
    iso: "GR",
    country_code: "30",
    name_en: "Greece",
    name_he: "יוון",
    icon: "https://flagcdn.com/w40/gr.png"
  },
  {
    id: "GL",
    iso: "GL",
    country_code: "299",
    name_en: "Greenland",
    name_he: "גרינלנד",
    icon: "https://flagcdn.com/w40/gl.png"
  },
  {
    id: "GD",
    iso: "GD",
    country_code: "1",
    name_en: "Grenada",
    name_he: "גרנדה",
    icon: "https://flagcdn.com/w40/gd.png"
  },
  {
    id: "GP",
    iso: "GP",
    country_code: "590",
    name_en: "Guadeloupe",
    name_he: "גוואדלופ",
    icon: "https://flagcdn.com/w40/gp.png"
  },
  {
    id: "GU",
    iso: "GU",
    country_code: "1",
    name_en: "Guam",
    name_he: "גואם",
    icon: "https://flagcdn.com/w40/gu.png"
  },
  {
    id: "GT",
    iso: "GT",
    country_code: "502",
    name_en: "Guatemala",
    name_he: "גואטמלה",
    icon: "https://flagcdn.com/w40/gt.png"
  },
  {
    id: "GG",
    iso: "GG",
    country_code: "44",
    name_en: "Guernsey",
    name_he: "גרנזי",
    icon: "https://flagcdn.com/w40/gg.png"
  },
  {
    id: "GN",
    iso: "GN",
    country_code: "224",
    name_en: "Guinea",
    name_he: "גינאה",
    icon: "https://flagcdn.com/w40/gn.png"
  },
  {
    id: "GW",
    iso: "GW",
    country_code: "245",
    name_en: "Guinea-Bissau",
    name_he: "גינאה-ביסאו",
    icon: "https://flagcdn.com/w40/gw.png"
  },
  {
    id: "GY",
    iso: "GY",
    country_code: "592",
    name_en: "Guyana",
    name_he: "גיאנה",
    icon: "https://flagcdn.com/w40/gy.png"
  },
  {
    id: "HT",
    iso: "HT",
    country_code: "509",
    name_en: "Haiti",
    name_he: "האיטי",
    icon: "https://flagcdn.com/w40/ht.png"
  },
  {
    id: "HN",
    iso: "HN",
    country_code: "504",
    name_en: "Honduras",
    name_he: "הונדורס",
    icon: "https://flagcdn.com/w40/hn.png"
  },
  {
    id: "HK",
    iso: "HK",
    country_code: "852",
    name_en: "Hong Kong SAR China",
    name_he: "הונג קונג (אזור מנהלי מיוחד של סין)",
    icon: "https://flagcdn.com/w40/hk.png"
  },
  {
    id: "HU",
    iso: "HU",
    country_code: "36",
    name_en: "Hungary",
    name_he: "הונגריה",
    icon: "https://flagcdn.com/w40/hu.png"
  },
  {
    id: "IS",
    iso: "IS",
    country_code: "354",
    name_en: "Iceland",
    name_he: "איסלנד",
    icon: "https://flagcdn.com/w40/is.png"
  },
  {
    id: "IN",
    iso: "IN",
    country_code: "91",
    name_en: "India",
    name_he: "הודו",
    icon: "https://flagcdn.com/w40/in.png"
  },
  {
    id: "ID",
    iso: "ID",
    country_code: "62",
    name_en: "Indonesia",
    name_he: "אינדונזיה",
    icon: "https://flagcdn.com/w40/id.png"
  },
  {
    id: "IR",
    iso: "IR",
    country_code: "98",
    name_en: "Iran",
    name_he: "איראן",
    icon: "https://flagcdn.com/w40/ir.png"
  },
  {
    id: "IQ",
    iso: "IQ",
    country_code: "964",
    name_en: "Iraq",
    name_he: "עיראק",
    icon: "https://flagcdn.com/w40/iq.png"
  },
  {
    id: "IE",
    iso: "IE",
    country_code: "353",
    name_en: "Ireland",
    name_he: "אירלנד",
    icon: "https://flagcdn.com/w40/ie.png"
  },
  {
    id: "IM",
    iso: "IM",
    country_code: "44",
    name_en: "Isle of Man",
    name_he: "האי מאן",
    icon: "https://flagcdn.com/w40/im.png"
  },
  {
    id: "IL",
    iso: "IL",
    country_code: "972",
    name_en: "Israel",
    name_he: "ישראל",
    icon: "https://flagcdn.com/w40/il.png"
  },
  {
    id: "IT",
    iso: "IT",
    country_code: "39",
    name_en: "Italy",
    name_he: "איטליה",
    icon: "https://flagcdn.com/w40/it.png"
  },
  {
    id: "JM",
    iso: "JM",
    country_code: "1",
    name_en: "Jamaica",
    name_he: "ג׳מייקה",
    icon: "https://flagcdn.com/w40/jm.png"
  },
  {
    id: "JP",
    iso: "JP",
    country_code: "81",
    name_en: "Japan",
    name_he: "יפן",
    icon: "https://flagcdn.com/w40/jp.png"
  },
  {
    id: "JE",
    iso: "JE",
    country_code: "44",
    name_en: "Jersey",
    name_he: "ג׳רזי",
    icon: "https://flagcdn.com/w40/je.png"
  },
  {
    id: "JO",
    iso: "JO",
    country_code: "962",
    name_en: "Jordan",
    name_he: "ירדן",
    icon: "https://flagcdn.com/w40/jo.png"
  },
  {
    id: "KZ",
    iso: "KZ",
    country_code: "7",
    name_en: "Kazakhstan",
    name_he: "קזחסטן",
    icon: "https://flagcdn.com/w40/kz.png"
  },
  {
    id: "KE",
    iso: "KE",
    country_code: "254",
    name_en: "Kenya",
    name_he: "קניה",
    icon: "https://flagcdn.com/w40/ke.png"
  },
  {
    id: "KI",
    iso: "KI",
    country_code: "686",
    name_en: "Kiribati",
    name_he: "קיריבאטי",
    icon: "https://flagcdn.com/w40/ki.png"
  },
  {
    id: "XK",
    iso: "XK",
    country_code: "383",
    name_en: "Kosovo",
    name_he: "קוסובו",
    icon: "https://flagcdn.com/w40/xk.png"
  },
  {
    id: "KW",
    iso: "KW",
    country_code: "965",
    name_en: "Kuwait",
    name_he: "כווית",
    icon: "https://flagcdn.com/w40/kw.png"
  },
  {
    id: "KG",
    iso: "KG",
    country_code: "996",
    name_en: "Kyrgyzstan",
    name_he: "קירגיזסטן",
    icon: "https://flagcdn.com/w40/kg.png"
  },
  {
    id: "LA",
    iso: "LA",
    country_code: "856",
    name_en: "Laos",
    name_he: "לאוס",
    icon: "https://flagcdn.com/w40/la.png"
  },
  {
    id: "LV",
    iso: "LV",
    country_code: "371",
    name_en: "Latvia",
    name_he: "לטביה",
    icon: "https://flagcdn.com/w40/lv.png"
  },
  {
    id: "LB",
    iso: "LB",
    country_code: "961",
    name_en: "Lebanon",
    name_he: "לבנון",
    icon: "https://flagcdn.com/w40/lb.png"
  },
  {
    id: "LS",
    iso: "LS",
    country_code: "266",
    name_en: "Lesotho",
    name_he: "לסוטו",
    icon: "https://flagcdn.com/w40/ls.png"
  },
  {
    id: "LR",
    iso: "LR",
    country_code: "231",
    name_en: "Liberia",
    name_he: "ליבריה",
    icon: "https://flagcdn.com/w40/lr.png"
  },
  {
    id: "LY",
    iso: "LY",
    country_code: "218",
    name_en: "Libya",
    name_he: "לוב",
    icon: "https://flagcdn.com/w40/ly.png"
  },
  {
    id: "LI",
    iso: "LI",
    country_code: "423",
    name_en: "Liechtenstein",
    name_he: "ליכטנשטיין",
    icon: "https://flagcdn.com/w40/li.png"
  },
  {
    id: "LT",
    iso: "LT",
    country_code: "370",
    name_en: "Lithuania",
    name_he: "ליטא",
    icon: "https://flagcdn.com/w40/lt.png"
  },
  {
    id: "LU",
    iso: "LU",
    country_code: "352",
    name_en: "Luxembourg",
    name_he: "לוקסמבורג",
    icon: "https://flagcdn.com/w40/lu.png"
  },
  {
    id: "MO",
    iso: "MO",
    country_code: "853",
    name_en: "Macao SAR China",
    name_he: "מקאו (אזור מנהלי מיוחד של סין)",
    icon: "https://flagcdn.com/w40/mo.png"
  },
  {
    id: "MG",
    iso: "MG",
    country_code: "261",
    name_en: "Madagascar",
    name_he: "מדגסקר",
    icon: "https://flagcdn.com/w40/mg.png"
  },
  {
    id: "MW",
    iso: "MW",
    country_code: "265",
    name_en: "Malawi",
    name_he: "מלאווי",
    icon: "https://flagcdn.com/w40/mw.png"
  },
  {
    id: "MY",
    iso: "MY",
    country_code: "60",
    name_en: "Malaysia",
    name_he: "מלזיה",
    icon: "https://flagcdn.com/w40/my.png"
  },
  {
    id: "MV",
    iso: "MV",
    country_code: "960",
    name_en: "Maldives",
    name_he: "האיים המלדיביים",
    icon: "https://flagcdn.com/w40/mv.png"
  },
  {
    id: "ML",
    iso: "ML",
    country_code: "223",
    name_en: "Mali",
    name_he: "מאלי",
    icon: "https://flagcdn.com/w40/ml.png"
  },
  {
    id: "MT",
    iso: "MT",
    country_code: "356",
    name_en: "Malta",
    name_he: "מלטה",
    icon: "https://flagcdn.com/w40/mt.png"
  },
  {
    id: "MH",
    iso: "MH",
    country_code: "692",
    name_en: "Marshall Islands",
    name_he: "איי מרשל",
    icon: "https://flagcdn.com/w40/mh.png"
  },
  {
    id: "MQ",
    iso: "MQ",
    country_code: "596",
    name_en: "Martinique",
    name_he: "מרטיניק",
    icon: "https://flagcdn.com/w40/mq.png"
  },
  {
    id: "MR",
    iso: "MR",
    country_code: "222",
    name_en: "Mauritania",
    name_he: "מאוריטניה",
    icon: "https://flagcdn.com/w40/mr.png"
  },
  {
    id: "MU",
    iso: "MU",
    country_code: "230",
    name_en: "Mauritius",
    name_he: "מאוריציוס",
    icon: "https://flagcdn.com/w40/mu.png"
  },
  {
    id: "YT",
    iso: "YT",
    country_code: "262",
    name_en: "Mayotte",
    name_he: "מאיוט",
    icon: "https://flagcdn.com/w40/yt.png"
  },
  {
    id: "MX",
    iso: "MX",
    country_code: "52",
    name_en: "Mexico",
    name_he: "מקסיקו",
    icon: "https://flagcdn.com/w40/mx.png"
  },
  {
    id: "FM",
    iso: "FM",
    country_code: "691",
    name_en: "Micronesia",
    name_he: "מיקרונזיה",
    icon: "https://flagcdn.com/w40/fm.png"
  },
  {
    id: "MD",
    iso: "MD",
    country_code: "373",
    name_en: "Moldova",
    name_he: "מולדובה",
    icon: "https://flagcdn.com/w40/md.png"
  },
  {
    id: "MC",
    iso: "MC",
    country_code: "377",
    name_en: "Monaco",
    name_he: "מונקו",
    icon: "https://flagcdn.com/w40/mc.png"
  },
  {
    id: "MN",
    iso: "MN",
    country_code: "976",
    name_en: "Mongolia",
    name_he: "מונגוליה",
    icon: "https://flagcdn.com/w40/mn.png"
  },
  {
    id: "ME",
    iso: "ME",
    country_code: "382",
    name_en: "Montenegro",
    name_he: "מונטנגרו",
    icon: "https://flagcdn.com/w40/me.png"
  },
  {
    id: "MS",
    iso: "MS",
    country_code: "1",
    name_en: "Montserrat",
    name_he: "מונסראט",
    icon: "https://flagcdn.com/w40/ms.png"
  },
  {
    id: "MA",
    iso: "MA",
    country_code: "212",
    name_en: "Morocco",
    name_he: "מרוקו",
    icon: "https://flagcdn.com/w40/ma.png"
  },
  {
    id: "MZ",
    iso: "MZ",
    country_code: "258",
    name_en: "Mozambique",
    name_he: "מוזמביק",
    icon: "https://flagcdn.com/w40/mz.png"
  },
  {
    id: "MM",
    iso: "MM",
    country_code: "95",
    name_en: "Myanmar (Burma)",
    name_he: "מיאנמר (בורמה)",
    icon: "https://flagcdn.com/w40/mm.png"
  },
  {
    id: "NA",
    iso: "NA",
    country_code: "264",
    name_en: "Namibia",
    name_he: "נמיביה",
    icon: "https://flagcdn.com/w40/na.png"
  },
  {
    id: "NR",
    iso: "NR",
    country_code: "674",
    name_en: "Nauru",
    name_he: "נאורו",
    icon: "https://flagcdn.com/w40/nr.png"
  },
  {
    id: "NP",
    iso: "NP",
    country_code: "977",
    name_en: "Nepal",
    name_he: "נפאל",
    icon: "https://flagcdn.com/w40/np.png"
  },
  {
    id: "NL",
    iso: "NL",
    country_code: "31",
    name_en: "Netherlands",
    name_he: "הולנד",
    icon: "https://flagcdn.com/w40/nl.png"
  },
  {
    id: "NC",
    iso: "NC",
    country_code: "687",
    name_en: "New Caledonia",
    name_he: "קלדוניה החדשה",
    icon: "https://flagcdn.com/w40/nc.png"
  },
  {
    id: "NZ",
    iso: "NZ",
    country_code: "64",
    name_en: "New Zealand",
    name_he: "ניו זילנד",
    icon: "https://flagcdn.com/w40/nz.png"
  },
  {
    id: "NI",
    iso: "NI",
    country_code: "505",
    name_en: "Nicaragua",
    name_he: "ניקרגואה",
    icon: "https://flagcdn.com/w40/ni.png"
  },
  {
    id: "NE",
    iso: "NE",
    country_code: "227",
    name_en: "Niger",
    name_he: "ניז׳ר",
    icon: "https://flagcdn.com/w40/ne.png"
  },
  {
    id: "NG",
    iso: "NG",
    country_code: "234",
    name_en: "Nigeria",
    name_he: "ניגריה",
    icon: "https://flagcdn.com/w40/ng.png"
  },
  {
    id: "NU",
    iso: "NU",
    country_code: "683",
    name_en: "Niue",
    name_he: "ניווה",
    icon: "https://flagcdn.com/w40/nu.png"
  },
  {
    id: "NF",
    iso: "NF",
    country_code: "672",
    name_en: "Norfolk Island",
    name_he: "האי נורפוק",
    icon: "https://flagcdn.com/w40/nf.png"
  },
  {
    id: "KP",
    iso: "KP",
    country_code: "850",
    name_en: "North Korea",
    name_he: "קוריאה הצפונית",
    icon: "https://flagcdn.com/w40/kp.png"
  },
  {
    id: "MK",
    iso: "MK",
    country_code: "389",
    name_en: "North Macedonia",
    name_he: "מקדוניה הצפונית",
    icon: "https://flagcdn.com/w40/mk.png"
  },
  {
    id: "MP",
    iso: "MP",
    country_code: "1",
    name_en: "Northern Mariana Islands",
    name_he: "איי מריאנה הצפוניים",
    icon: "https://flagcdn.com/w40/mp.png"
  },
  {
    id: "NO",
    iso: "NO",
    country_code: "47",
    name_en: "Norway",
    name_he: "נורווגיה",
    icon: "https://flagcdn.com/w40/no.png"
  },
  {
    id: "OM",
    iso: "OM",
    country_code: "968",
    name_en: "Oman",
    name_he: "עומאן",
    icon: "https://flagcdn.com/w40/om.png"
  },
  {
    id: "PK",
    iso: "PK",
    country_code: "92",
    name_en: "Pakistan",
    name_he: "פקיסטן",
    icon: "https://flagcdn.com/w40/pk.png"
  },
  {
    id: "PW",
    iso: "PW",
    country_code: "680",
    name_en: "Palau",
    name_he: "פלאו",
    icon: "https://flagcdn.com/w40/pw.png"
  },
  {
    id: "PS",
    iso: "PS",
    country_code: "970",
    name_en: "Palestinian Territories",
    name_he: "השטחים הפלסטיניים",
    icon: "https://flagcdn.com/w40/ps.png"
  },
  {
    id: "PA",
    iso: "PA",
    country_code: "507",
    name_en: "Panama",
    name_he: "פנמה",
    icon: "https://flagcdn.com/w40/pa.png"
  },
  {
    id: "PG",
    iso: "PG",
    country_code: "675",
    name_en: "Papua New Guinea",
    name_he: "פפואה גינאה החדשה",
    icon: "https://flagcdn.com/w40/pg.png"
  },
  {
    id: "PY",
    iso: "PY",
    country_code: "595",
    name_en: "Paraguay",
    name_he: "פרגוואי",
    icon: "https://flagcdn.com/w40/py.png"
  },
  {
    id: "PE",
    iso: "PE",
    country_code: "51",
    name_en: "Peru",
    name_he: "פרו",
    icon: "https://flagcdn.com/w40/pe.png"
  },
  {
    id: "PH",
    iso: "PH",
    country_code: "63",
    name_en: "Philippines",
    name_he: "הפיליפינים",
    icon: "https://flagcdn.com/w40/ph.png"
  },
  {
    id: "PL",
    iso: "PL",
    country_code: "48",
    name_en: "Poland",
    name_he: "פולין",
    icon: "https://flagcdn.com/w40/pl.png"
  },
  {
    id: "PT",
    iso: "PT",
    country_code: "351",
    name_en: "Portugal",
    name_he: "פורטוגל",
    icon: "https://flagcdn.com/w40/pt.png"
  },
  {
    id: "PR",
    iso: "PR",
    country_code: "1",
    name_en: "Puerto Rico",
    name_he: "פוארטו ריקו",
    icon: "https://flagcdn.com/w40/pr.png"
  },
  {
    id: "QA",
    iso: "QA",
    country_code: "974",
    name_en: "Qatar",
    name_he: "קטאר",
    icon: "https://flagcdn.com/w40/qa.png"
  },
  {
    id: "RE",
    iso: "RE",
    country_code: "262",
    name_en: "Réunion",
    name_he: "ראוניון",
    icon: "https://flagcdn.com/w40/re.png"
  },
  {
    id: "RO",
    iso: "RO",
    country_code: "40",
    name_en: "Romania",
    name_he: "רומניה",
    icon: "https://flagcdn.com/w40/ro.png"
  },
  {
    id: "RU",
    iso: "RU",
    country_code: "7",
    name_en: "Russia",
    name_he: "רוסיה",
    icon: "https://flagcdn.com/w40/ru.png"
  },
  {
    id: "RW",
    iso: "RW",
    country_code: "250",
    name_en: "Rwanda",
    name_he: "רואנדה",
    icon: "https://flagcdn.com/w40/rw.png"
  },
  {
    id: "WS",
    iso: "WS",
    country_code: "685",
    name_en: "Samoa",
    name_he: "סמואה",
    icon: "https://flagcdn.com/w40/ws.png"
  },
  {
    id: "SM",
    iso: "SM",
    country_code: "378",
    name_en: "San Marino",
    name_he: "סן מרינו",
    icon: "https://flagcdn.com/w40/sm.png"
  },
  {
    id: "ST",
    iso: "ST",
    country_code: "239",
    name_en: "São Tomé & Príncipe",
    name_he: "סאו טומה ופרינסיפה",
    icon: "https://flagcdn.com/w40/st.png"
  },
  {
    id: "SA",
    iso: "SA",
    country_code: "966",
    name_en: "Saudi Arabia",
    name_he: "ערב הסעודית",
    icon: "https://flagcdn.com/w40/sa.png"
  },
  {
    id: "SN",
    iso: "SN",
    country_code: "221",
    name_en: "Senegal",
    name_he: "סנגל",
    icon: "https://flagcdn.com/w40/sn.png"
  },
  {
    id: "RS",
    iso: "RS",
    country_code: "381",
    name_en: "Serbia",
    name_he: "סרביה",
    icon: "https://flagcdn.com/w40/rs.png"
  },
  {
    id: "SC",
    iso: "SC",
    country_code: "248",
    name_en: "Seychelles",
    name_he: "איי סיישל",
    icon: "https://flagcdn.com/w40/sc.png"
  },
  {
    id: "SL",
    iso: "SL",
    country_code: "232",
    name_en: "Sierra Leone",
    name_he: "סיירה לאון",
    icon: "https://flagcdn.com/w40/sl.png"
  },
  {
    id: "SG",
    iso: "SG",
    country_code: "65",
    name_en: "Singapore",
    name_he: "סינגפור",
    icon: "https://flagcdn.com/w40/sg.png"
  },
  {
    id: "SX",
    iso: "SX",
    country_code: "1",
    name_en: "Sint Maarten",
    name_he: "סנט מארטן",
    icon: "https://flagcdn.com/w40/sx.png"
  },
  {
    id: "SK",
    iso: "SK",
    country_code: "421",
    name_en: "Slovakia",
    name_he: "סלובקיה",
    icon: "https://flagcdn.com/w40/sk.png"
  },
  {
    id: "SI",
    iso: "SI",
    country_code: "386",
    name_en: "Slovenia",
    name_he: "סלובניה",
    icon: "https://flagcdn.com/w40/si.png"
  },
  {
    id: "SB",
    iso: "SB",
    country_code: "677",
    name_en: "Solomon Islands",
    name_he: "איי שלמה",
    icon: "https://flagcdn.com/w40/sb.png"
  },
  {
    id: "SO",
    iso: "SO",
    country_code: "252",
    name_en: "Somalia",
    name_he: "סומליה",
    icon: "https://flagcdn.com/w40/so.png"
  },
  {
    id: "ZA",
    iso: "ZA",
    country_code: "27",
    name_en: "South Africa",
    name_he: "דרום אפריקה",
    icon: "https://flagcdn.com/w40/za.png"
  },
  {
    id: "KR",
    iso: "KR",
    country_code: "82",
    name_en: "South Korea",
    name_he: "קוריאה הדרומית",
    icon: "https://flagcdn.com/w40/kr.png"
  },
  {
    id: "SS",
    iso: "SS",
    country_code: "211",
    name_en: "South Sudan",
    name_he: "דרום סודן",
    icon: "https://flagcdn.com/w40/ss.png"
  },
  {
    id: "ES",
    iso: "ES",
    country_code: "34",
    name_en: "Spain",
    name_he: "ספרד",
    icon: "https://flagcdn.com/w40/es.png"
  },
  {
    id: "LK",
    iso: "LK",
    country_code: "94",
    name_en: "Sri Lanka",
    name_he: "סרי לנקה",
    icon: "https://flagcdn.com/w40/lk.png"
  },
  {
    id: "BL",
    iso: "BL",
    country_code: "590",
    name_en: "St. Barthélemy",
    name_he: "סנט ברתולומיאו",
    icon: "https://flagcdn.com/w40/bl.png"
  },
  {
    id: "SH",
    iso: "SH",
    country_code: "290",
    name_en: "St. Helena",
    name_he: "סנט הלנה",
    icon: "https://flagcdn.com/w40/sh.png"
  },
  {
    id: "KN",
    iso: "KN",
    country_code: "1",
    name_en: "St. Kitts & Nevis",
    name_he: "סנט קיטס ונוויס",
    icon: "https://flagcdn.com/w40/kn.png"
  },
  {
    id: "LC",
    iso: "LC",
    country_code: "1",
    name_en: "St. Lucia",
    name_he: "סנט לוסיה",
    icon: "https://flagcdn.com/w40/lc.png"
  },
  {
    id: "MF",
    iso: "MF",
    country_code: "590",
    name_en: "St. Martin",
    name_he: "סן מרטן",
    icon: "https://flagcdn.com/w40/mf.png"
  },
  {
    id: "PM",
    iso: "PM",
    country_code: "508",
    name_en: "St. Pierre & Miquelon",
    name_he: "סנט פייר ומיקלון",
    icon: "https://flagcdn.com/w40/pm.png"
  },
  {
    id: "VC",
    iso: "VC",
    country_code: "1",
    name_en: "St. Vincent & Grenadines",
    name_he: "סנט וינסנט והגרנדינים",
    icon: "https://flagcdn.com/w40/vc.png"
  },
  {
    id: "SD",
    iso: "SD",
    country_code: "249",
    name_en: "Sudan",
    name_he: "סודן",
    icon: "https://flagcdn.com/w40/sd.png"
  },
  {
    id: "SR",
    iso: "SR",
    country_code: "597",
    name_en: "Suriname",
    name_he: "סורינאם",
    icon: "https://flagcdn.com/w40/sr.png"
  },
  {
    id: "SJ",
    iso: "SJ",
    country_code: "47",
    name_en: "Svalbard & Jan Mayen",
    name_he: "סבאלברד ויאן מאיין",
    icon: "https://flagcdn.com/w40/sj.png"
  },
  {
    id: "SE",
    iso: "SE",
    country_code: "46",
    name_en: "Sweden",
    name_he: "שוודיה",
    icon: "https://flagcdn.com/w40/se.png"
  },
  {
    id: "CH",
    iso: "CH",
    country_code: "41",
    name_en: "Switzerland",
    name_he: "שווייץ",
    icon: "https://flagcdn.com/w40/ch.png"
  },
  {
    id: "SY",
    iso: "SY",
    country_code: "963",
    name_en: "Syria",
    name_he: "סוריה",
    icon: "https://flagcdn.com/w40/sy.png"
  },
  {
    id: "TW",
    iso: "TW",
    country_code: "886",
    name_en: "Taiwan",
    name_he: "טייוואן",
    icon: "https://flagcdn.com/w40/tw.png"
  },
  {
    id: "TJ",
    iso: "TJ",
    country_code: "992",
    name_en: "Tajikistan",
    name_he: "טג׳יקיסטן",
    icon: "https://flagcdn.com/w40/tj.png"
  },
  {
    id: "TZ",
    iso: "TZ",
    country_code: "255",
    name_en: "Tanzania",
    name_he: "טנזניה",
    icon: "https://flagcdn.com/w40/tz.png"
  },
  {
    id: "TH",
    iso: "TH",
    country_code: "66",
    name_en: "Thailand",
    name_he: "תאילנד",
    icon: "https://flagcdn.com/w40/th.png"
  },
  {
    id: "TL",
    iso: "TL",
    country_code: "670",
    name_en: "Timor-Leste",
    name_he: "טימור-לסטה",
    icon: "https://flagcdn.com/w40/tl.png"
  },
  {
    id: "TG",
    iso: "TG",
    country_code: "228",
    name_en: "Togo",
    name_he: "טוגו",
    icon: "https://flagcdn.com/w40/tg.png"
  },
  {
    id: "TK",
    iso: "TK",
    country_code: "690",
    name_en: "Tokelau",
    name_he: "טוקלאו",
    icon: "https://flagcdn.com/w40/tk.png"
  },
  {
    id: "TO",
    iso: "TO",
    country_code: "676",
    name_en: "Tonga",
    name_he: "טונגה",
    icon: "https://flagcdn.com/w40/to.png"
  },
  {
    id: "TT",
    iso: "TT",
    country_code: "1",
    name_en: "Trinidad & Tobago",
    name_he: "טרינידד וטובגו",
    icon: "https://flagcdn.com/w40/tt.png"
  },
  {
    id: "TA",
    iso: "TA",
    country_code: "290",
    name_en: "Tristan da Cunha",
    name_he: "טריסטן דה קונה",
    icon: "https://flagcdn.com/w40/ta.png"
  },
  {
    id: "TN",
    iso: "TN",
    country_code: "216",
    name_en: "Tunisia",
    name_he: "תוניסיה",
    icon: "https://flagcdn.com/w40/tn.png"
  },
  {
    id: "TR",
    iso: "TR",
    country_code: "90",
    name_en: "Türkiye",
    name_he: "טורקיה",
    icon: "https://flagcdn.com/w40/tr.png"
  },
  {
    id: "TM",
    iso: "TM",
    country_code: "993",
    name_en: "Turkmenistan",
    name_he: "טורקמניסטן",
    icon: "https://flagcdn.com/w40/tm.png"
  },
  {
    id: "TC",
    iso: "TC",
    country_code: "1",
    name_en: "Turks & Caicos Islands",
    name_he: "איי טרקס וקייקוס",
    icon: "https://flagcdn.com/w40/tc.png"
  },
  {
    id: "TV",
    iso: "TV",
    country_code: "688",
    name_en: "Tuvalu",
    name_he: "טובאלו",
    icon: "https://flagcdn.com/w40/tv.png"
  },
  {
    id: "VI",
    iso: "VI",
    country_code: "1",
    name_en: "U.S. Virgin Islands",
    name_he: "איי הבתולה של ארצות הברית",
    icon: "https://flagcdn.com/w40/vi.png"
  },
  {
    id: "UG",
    iso: "UG",
    country_code: "256",
    name_en: "Uganda",
    name_he: "אוגנדה",
    icon: "https://flagcdn.com/w40/ug.png"
  },
  {
    id: "UA",
    iso: "UA",
    country_code: "380",
    name_en: "Ukraine",
    name_he: "אוקראינה",
    icon: "https://flagcdn.com/w40/ua.png"
  },
  {
    id: "AE",
    iso: "AE",
    country_code: "971",
    name_en: "United Arab Emirates",
    name_he: "איחוד האמירויות הערביות",
    icon: "https://flagcdn.com/w40/ae.png"
  },
  {
    id: "GB",
    iso: "GB",
    country_code: "44",
    name_en: "United Kingdom",
    name_he: "בריטניה",
    icon: "https://flagcdn.com/w40/gb.png"
  },
  {
    id: "US",
    iso: "US",
    country_code: "1",
    name_en: "United States",
    name_he: "ארצות הברית",
    icon: "https://flagcdn.com/w40/us.png"
  },
  {
    id: "UY",
    iso: "UY",
    country_code: "598",
    name_en: "Uruguay",
    name_he: "אורוגוואי",
    icon: "https://flagcdn.com/w40/uy.png"
  },
  {
    id: "UZ",
    iso: "UZ",
    country_code: "998",
    name_en: "Uzbekistan",
    name_he: "אוזבקיסטן",
    icon: "https://flagcdn.com/w40/uz.png"
  },
  {
    id: "VU",
    iso: "VU",
    country_code: "678",
    name_en: "Vanuatu",
    name_he: "ונואטו",
    icon: "https://flagcdn.com/w40/vu.png"
  },
  {
    id: "VA",
    iso: "VA",
    country_code: "39",
    name_en: "Vatican City",
    name_he: "הוותיקן",
    icon: "https://flagcdn.com/w40/va.png"
  },
  {
    id: "VE",
    iso: "VE",
    country_code: "58",
    name_en: "Venezuela",
    name_he: "ונצואלה",
    icon: "https://flagcdn.com/w40/ve.png"
  },
  {
    id: "VN",
    iso: "VN",
    country_code: "84",
    name_en: "Vietnam",
    name_he: "וייטנאם",
    icon: "https://flagcdn.com/w40/vn.png"
  },
  {
    id: "WF",
    iso: "WF",
    country_code: "681",
    name_en: "Wallis & Futuna",
    name_he: "איי ווליס ופוטונה",
    icon: "https://flagcdn.com/w40/wf.png"
  },
  {
    id: "EH",
    iso: "EH",
    country_code: "212",
    name_en: "Western Sahara",
    name_he: "סהרה המערבית",
    icon: "https://flagcdn.com/w40/eh.png"
  },
  {
    id: "YE",
    iso: "YE",
    country_code: "967",
    name_en: "Yemen",
    name_he: "תימן",
    icon: "https://flagcdn.com/w40/ye.png"
  },
  {
    id: "ZM",
    iso: "ZM",
    country_code: "260",
    name_en: "Zambia",
    name_he: "זמביה",
    icon: "https://flagcdn.com/w40/zm.png"
  },
  {
    id: "ZW",
    iso: "ZW",
    country_code: "263",
    name_en: "Zimbabwe",
    name_he: "זימבבואה",
    icon: "https://flagcdn.com/w40/zw.png"
  }
]
